import React from 'react';

import Icon from '@/components/common/icon';

export default [
  {
    label: 'adminapp_menu_import',
    icon: <Icon name="play" className="text-info iconRightMarginMax" />,
    roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
    path: 'import'
  },
  {
    label: 'adminapp_menu_import_rh',
    icon: <Icon name="play" className="text-info iconRightMarginMax" />,
    roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
    path: 'import/rh'
  },
  {
    label: 'adminapp_menu_import_referencing_club',
    icon: <Icon name="play" className="text-info iconRightMarginMax" />,
    roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
    path: 'import/referencing_club'
  },
  {
    label: 'adminapp_menu_import_geometries',
    icon: <Icon name="play" className="text-info iconRightMarginMax" />,
    roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
    path: 'import/geometries'
  }
];
